import React, { useState } from "react";
import * as style from "../Hooks/style";

export const TopMenu = ({ scrollToLinkA, scrollToLinkB, scrollToLinkC, scrollToLinkD, scrollToLinkE, active1, active2, active3, active4, active5 }) => {
  const [toggle, setToggle] = useState(false);
  function handleToggle() {
    if (toggle === false) {
      setToggle(true);
    } else if (toggle === true) {
      setToggle(false);
    }
  }
  return (
    <>
      <style.styledMobileMenu mobile={toggle} onMouseUp={handleToggle} />
      <style.styledMobileMenuClose mobile={toggle} onMouseUp={handleToggle} />
      <style.styledTopMenu mobile={toggle}>
        <style.styledTopMenuSub
          onClick={() => {
            scrollToLinkA();
            handleToggle();
          }}
          active={active1}
          mobile={toggle}
        >
          MarinaX
        </style.styledTopMenuSub>
        <style.styledTopMenuSub
          onClick={() => {
            scrollToLinkB();
            handleToggle();
          }}
          active={active2}
          mobile={toggle}
        >
          Experience
        </style.styledTopMenuSub>
        <style.styledTopMenuSub
          onClick={() => {
            scrollToLinkC();
            handleToggle();
          }}
          active={active3}
          mobile={toggle}
        >
          Why MarinaX{" "}
        </style.styledTopMenuSub>
        <style.styledTopMenuSub
          onClick={() => {
            scrollToLinkD();
            handleToggle();
          }}
          active={active4}
          mobile={toggle}
        >
          Product
        </style.styledTopMenuSub>
        <style.styledTopMenuSub
          onClick={() => {
            scrollToLinkE();
            handleToggle();
          }}
          active={active5}
          mobile={toggle}
        >
          Contact Us
        </style.styledTopMenuSub>
      </style.styledTopMenu>
    </>
  );
};
